import React from 'react'
import { Layout, Menu, Radio, Switch, List } from 'antd'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  AppstoreOutlined,
  BarsOutlined,
} from '@ant-design/icons'
import { withTranslation } from 'react-i18next'
import CatalogCategories from '../catalog/catalog-categories'
import { PRODUCTS_RESULT_MODE } from '../../constants/DefaultUserConfig'
import { connect } from 'react-redux'
import { setUserConfig, setFilterByStock } from '../../actions'

const { Sider } = Layout

class SiderComponent extends React.Component {
  componentDidMount() {
    const filterByStock = localStorage.getItem('filterByStock') === 'true'
    this.props.setFilterByStock(filterByStock)
  }

  handleViewChange = (e) => {
    this.props.setUserConfig({ viewResultMode: e.target.value })
  }

  handleFilterChange = (checked) => {
    this.props.setFilterByStock(checked)
    localStorage.setItem('filterByStock', checked)
  }

  render() {
    const { collapsed, handleCollapse, isMobile, t, products, view, filterByStock } = this.props

    if (isMobile && collapsed) {
      return null
    }

    return (
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={handleCollapse}
        trigger={null}
        className={collapsed ? '' : 'sider-expanded'}
      >
        <div className={`custom-trigger ${collapsed ? 'collapsed' : 'expanded'}`}>
          {collapsed ? (
            <MenuUnfoldOutlined onClick={() => handleCollapse(true)} />
          ) : (
            <MenuFoldOutlined onClick={() => handleCollapse(false)} />
          )}
        </div>
        {!collapsed && (
          <div className='sider-options'>
            <List
              itemLayout='horizontal'
              dataSource={[
                {
                  title: (
                    <div className='sider-option'>
                      <span>{t('filterProductsByStock')}</span>
                      <Switch checked={filterByStock} onChange={this.handleFilterChange} />
                    </div>
                  ),
                },
                products.data &&
                  products.data.length > 0 && {
                    title: (
                      <div className='sider-option'>
                        <span>{t('View')}</span>
                        <Radio.Group onChange={this.handleViewChange} value={view}>
                          <Radio.Button value={PRODUCTS_RESULT_MODE.GRID}>
                            <AppstoreOutlined />
                          </Radio.Button>
                          <Radio.Button value={PRODUCTS_RESULT_MODE.TABLE}>
                            <BarsOutlined />
                          </Radio.Button>
                        </Radio.Group>
                      </div>
                    ),
                  },
              ].filter(Boolean)}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta title={item.title} />
                </List.Item>
              )}
            />
          </div>
        )}
        <CatalogCategories isMobile={isMobile} />
      </Sider>
    )
  }
}

const mapStateToProps = ({ userConfig, catalog }) => {
  const { config } = userConfig
  const { products, filterByStock } = catalog

  return {
    view: config.viewResultMode,
    products,
    filterByStock,
  }
}

const mapDispatchToProps = {
  setUserConfig,
  setFilterByStock,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SiderComponent))
